<template>
	<div class="full">
		<vxe-grid ref="invoicesuggestionTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				list_footerField:[
					{field:'endAmount',toFixed:4}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'inventoryName',
						title: '项目名称',
					},
					{
						field: 'endAmount',
						title: '结存金额',
						sortable:true,
						slots:{
							default:({row})=>{
								if(row.endAmount<0){
									return <span style="color:#F56C6C">{row.endAmount}</span>
								}else{
									return row.endAmount
								}
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
			},
			list() {
				return new Promise((resolve) => {
					let res = JSON.parse(JSON.stringify(this.store.inventoryreport))
					let data = []
					let group = this.$Lodash.groupBy(res,'inventoryName')
					//console.log(group)
					for(let i in group){
						let obj = group[i][0]
						obj.endAmount = this.$Lodash.sumBy(group[i],(item)=>{
							return parseFloat(item.endAmount)
						})
						obj.endAmount = obj.endAmount.toFixed(4)
						data.push(obj)
					}
					data = this.$Lodash.sortBy(data,(item)=>{
						return parseFloat(item.endAmount)
					})
					//console.log(this.invoicedetailgroupdata)
					
					resolve({
						list: data
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>